import { z } from 'zod';
import { componentStyleSchema } from '../component-catalog.js';
const commonOptionals = {
    queryConfig: z.record(z.string(), z.unknown()).optional(),
    minimized: z.boolean().optional(),
    displayConfig: z.record(z.string(), z.unknown()).optional(),
    annotations: z.array(z.record(z.string(), z.unknown())).optional(),
    style: componentStyleSchema.optional(),
};
const propsSchema = z
    .object({
    sourceDataset: z.string(),
    mapping: z.object({ stage: z.string(), value: z.string() }).strict(),
    ...commonOptionals,
})
    .strict();
export const funnelChartDefinition = {
    type: 'FunnelChart',
    category: 'data',
    propsSchema,
    isDataBacked: true,
    columnRefManifest: ['stage', 'value'],
    needsMeasuredDims: true,
    defaultMinHeight: 200,
    description: 'Funnel chart over a dataset. Props: sourceDataset (required), mapping ({ stage: string, value: string }).',
};
//# sourceMappingURL=FunnelChart.js.map